import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { bootstrapApplication, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';


bootstrapApplication(App, {
    ...appConfig,
    providers: [
      ...(appConfig.providers || []),
      { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey }, 
      provideClientHydration(withEventReplay()),
    ]
  })
  .then(appRef => {
    const platformId = appRef.injector.get(PLATFORM_ID);
    if (isPlatformBrowser(platformId)) {
      import('hammerjs').catch(err => 
        console.error('HammerJS load error:', err));
    }
  })
  .catch((err) => console.error(err));
